import React, { useContext } from "react"
import TermsKdfContent from "../../utis/TermsKdfContent"
import TermsAndPolicyContent from "../../utis/TermsAndPolicyContent"
import TermsAndPolicyModal from "./TermsAndPolicyModal"
import { networkService } from "../config/axios"
import UserInfoContext from "../../utis/userInfoContext"
import { csrfToken } from "../../utis/csrfTokenUtils"
import Button from "../Elements/Button"

const TermsModals = ({ openTerms, setOpenTerms, refetch }) => {
    const { userInfoData, showCreateTerms, setShowCreateTerms, setShowNotifications } = useContext(UserInfoContext)

    //accept the terms while creating first kdf 
    const handleAcceptTerms = async () => {
        const data = {
            authenticity_token: csrfToken(),
        };
        await networkService(`update_tos.json`, "POST", data)
            .then((response) => {
                if (response.status == 200) {
                    refetch()
                    setShowNotifications({
                        showToast: true,
                        toastType: "success",
                        toastMessage: "Terms accepted",
                    });
                }
                setShowCreateTerms(false)
            })
            .catch((error) => {
                setShowNotifications({
                    showToast: true,
                    toastType: "danger",
                    toastMessage:
                        error?.response?.data?.errors?.email[0] ?? "Something went wrong",
                });
            });
    };

    //accept the terms policy
    const handleAcceptPolicyTerms = async () => {
        if (!userInfoData?.id) {
            setOpenTerms(false);
            return;
        }
        const data = {
            authenticity_token: csrfToken(),
            id: userInfoData?.id,
            user: {
                privacy_accepted: true
            },
        };
        await networkService(`admin/users/${userInfoData?.id}.json`, "PATCH", data)
            .then((response) => {
                if (response.status == 200) {
                    refetch()
                    setShowNotifications({
                        showToast: true,
                        toastType: "success",
                        toastMessage: `Terms acccepted`,
                    });
                }
                setOpenTerms(false)
            })
            .catch((error) => {
                setShowNotifications({
                    showToast: true,
                    toastType: "danger",
                    toastMessage:
                        error?.response?.data?.errors?.email[0] ?? "Something went wrong",
                });
                setOpenTerms(false);
            });
    };

    return (
        <>
            {/* <MyProfileModal
                profileModalStaus={profileModalStaus}
                setProfileModalStaus={setProfileModalStaus}
                setOpenTerms={setOpenTerms}
            /> */}
            <TermsAndPolicyModal
                modalStatus={openTerms}
                modalActiveStatus={setOpenTerms}
                title="Privacy Notice"
                showCloseButton={true}
                footer={(hasScrolledToBottom) => (
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <span className="text-muted" style={{ fontSize: '0.875rem' }}>Please scroll down to read the entire document.</span>
                        <Button
                            classList={'success'}
                            type="submit"
                            onClick={() => handleAcceptPolicyTerms()}
                            text='I Agree'
                            disabled={!hasScrolledToBottom}
                        />
                    </div>
                )}
            >
                <TermsAndPolicyContent lastReviewed={userInfoData?.privacy_accepted_date} />
            </TermsAndPolicyModal>
            <TermsAndPolicyModal
                modalStatus={showCreateTerms}
                modalActiveStatus={() => setShowCreateTerms(false)}
                title="Before we can allow full access, please accept our Terms of Service"
                showCloseButton={false}
                footer={
                    <div className="d-flex justify-content-end">
                        <Button
                            classList={'success'}
                            onClick={() => handleAcceptTerms()}
                            text='I Agree'
                            type="submit" 
                        />
                    </div>
                }
            >
                <TermsKdfContent setOpenTerms={setOpenTerms} />
            </TermsAndPolicyModal>
        </>
    )
}
export default TermsModals
